import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ModalStep } from '../../utils/steps.js';
import { getActions } from './actions.js';
import { Network } from '@usecapsule/web-sdk';
// Omitting step from default here since it's set dynamically when the modal opens and closes
export const DEFAULT_MODAL_STATE = {
    flow: undefined,
    webAuthURLForLogin: undefined,
    webAuthURLForCreate: undefined,
    onModalStepChange: undefined,
    onRampPurchase: undefined,
    networks: [Network.ETHEREUM],
    loginWindow: undefined,
};
export const useModalStore = create()(persist((set, get) => (Object.assign(Object.assign({ step: ModalStep.SIGN_UP, onRampConfig: undefined }, DEFAULT_MODAL_STATE), getActions(set, get))), {
    name: '@CAPSULE/modalState',
    storage: createJSONStorage(() => sessionStorage),
    partialize: state => ({
        step: state.step,
        webAuthURLForLogin: state.webAuthURLForLogin,
        webAuthURLForCreate: state.webAuthURLForCreate,
        onRampConfig: state.onRampConfig,
        onRampPurchase: state.onRampPurchase,
        networks: state.networks,
    }),
}));
